<template>
    <van-row :gutter="[10, 10]" class="mb-2">
        <van-col :span="8" v-for="(item, index) in esimIsdns" :key="index">
            <div class="bg-white rounded-3 p-2 cs-esim" @click="handleSelectIsdn(item)"
                :class="{ active: activeIsdn === item.isdn }">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <p class="m-0" style="font-size: 8px">{{ $t("esim_phone_number") }}:</p>
                    <p class="text-green m-0" style="font-size: 12px">
                        ${{ item.price }}
                    </p>
                </div>
                <img src="@/static/eSim/svg/circle-check-solid.svg" alt="" class="cs-icon-check" />
                <div>
                    <p class="m-0" style="font-size: 12px">{{ item.isdn }}</p>
                </div>
            </div>
        </van-col>
    </van-row>
</template>
<script>
import { Button, Col, Row, Icon } from "vant";

export default {
    name: "CardIsdn",
    components: {
        [Row.name]: Row,
        [Col.name]: Col,
        [Button.name]: Button,
        [Icon.name]: Icon,
    },
    data() {
        return {
        };
    },
    props: {
        esimIsdns: {
            type: Array,
            required: true,
        },
        activeIsdn: {
            type: String,
            default: "",
        },
    },
    methods: {
        handleSelectIsdn(item) {
            this.$emit("item-isdn", item);
        },
    },
};
</script>
<style>
.cs-esim.active {
    border: 1px solid #D80F2C;
    border-radius: 0.5rem !important;
    position: relative;
}

.cs-esim .cs-icon-check {
    display: none;
    position: absolute;
    top: -5px;
    right: -5px;
    width: 12px;
    height: 12px;
}

.cs-esim.active .cs-icon-check {
    display: block;

}
</style>